/**
 * Middleware that tells listeners about every plain action once the reducers have taken it, for code
 * that reacts to what happened rather than to what the state now is (food/legacyReset.js). Thunks never
 * reach it. `onAction(listener)` returns a function that removes the listener.
 */
export default function actionListeners() {
	const listeners = new Set();
	const middleware = () => (next) => (action) => {
		const result = next(action);
		[...listeners].forEach((listener) => listener(action));
		return result;
	};
	const onAction = (listener) => {
		listeners.add(listener);
		return () => listeners.delete(listener);
	};
	return { middleware, onAction };
}
